<form [formGroup]="juteForm" fxLayout="column">
  <mat-checkbox class="has-jute-before" [disabled]="areAllFieldsDisabled" (change)="juteBeforePathChange($event)" formControlName="hasJuteBefore">
    <h3 class="font-weight-semibold">
      {{ 'PRODUCTION_ORDER.WEAVE_PLAN.JUTE.JUTE_BEFORE_PATH' | bmsTranslate }}
      <span *ngIf="!hasPermissionToAddJute()" class="b1 hint">({{ 'GENERAL.HINTS.UNAUTHORIZED' | bmsTranslate }})</span>
    </h3>
  </mat-checkbox>

  <div *ngIf="juteForm.get('hasJuteBefore').value" fxLayout="column" formGroupName="juteBefore">
    <div class="jute-before-position" fxLayout="row" fxLayoutGap="16px" fxFlexOrder="1" formGroupName="position" fxLayoutAlign="left center" *ngIf="canShowAddJuteBeforeOrAfterPathLabels()">
      <p class="b1 font-weight-semibold">{{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: 'PRODUCTION_ORDER.WEAVE_PLAN.JUTE.JUTE' | bmsTranslate} }}</p>

      <mat-checkbox formControlName="beforePathLabel">
        {{ 'PRODUCTION_ORDER.WEAVE_PLAN.JUTE.BEFORE_PATH_LABEL' | bmsTranslate }}
      </mat-checkbox>
      <mat-checkbox formControlName="afterPathLabel">
        {{ 'PRODUCTION_ORDER.WEAVE_PLAN.JUTE.AFTER_PATH_LABEL' | bmsTranslate }}
      </mat-checkbox>
    </div>

    <div class="jute-before-dimensions-container" fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="left center" fxFlexOrder="0">
      <mat-form-field fxFlex="30">
        <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
        <input matInput appL10nDecimal formControlName="commercialHeightInMM" type="number" min="0" />
        <span matSuffix>{{ 'GENERAL.UNIT.MILLIMETER' | bmsTranslate }}</span>
        <mat-error *ngIf="canShowErrorForFormControl('required', 'juteBefore.commercialHeightInMM')">
          {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
        </mat-error>
        <mat-error *ngIf="canShowErrorForFormControl('min', 'juteBefore.commercialHeightInMM')">
          {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
        </mat-error>
      </mat-form-field>
      <mat-form-field fxFlex="31">
        <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
        <input matInput appL10nDecimal formControlName="technicalHeightInPicks" type="number" min="0" />
        <span matSuffix>{{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}</span>
        <mat-error *ngIf="canShowErrorForFormControl('required', 'juteBefore.technicalHeightInPicks')">
          {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
        </mat-error>
        <mat-error *ngIf="canShowMultipleError('juteBefore.technicalHeightInPicks')">
          {{ 'GENERAL.ERRORS.MULTIPLE_VALUE' | bmsTranslate: {value: getMultipleValue()} }}
        </mat-error>
        <mat-error *ngIf="canShowErrorForFormControl('min', 'juteBefore.technicalHeightInPicks')">
          {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: machineQuality.weaveStructure.picksPerColorLine} }}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <mat-checkbox class="has-jute-after" [disabled]="areAllFieldsDisabled" (change)="juteAfterPathChange($event)" formControlName="hasJuteAfter">
    <h3 class="font-weight-semibold">
      {{ 'PRODUCTION_ORDER.WEAVE_PLAN.JUTE.JUTE_AFTER_PATH' | bmsTranslate }}
      <span *ngIf="!hasPermissionToAddJute()" class="b1 hint">({{ 'GENERAL.HINTS.UNAUTHORIZED' | bmsTranslate }})</span>
    </h3>
  </mat-checkbox>

  <div *ngIf="juteForm.get('hasJuteAfter').value" fxLayout="column" fxLayoutGap="16px" formGroupName="juteAfter">
    <mat-checkbox class="jute-after-same-as-jute-before" (change)="onJuteAfterPathIsSameAsBeforeChange($event)" formControlName="sameAsJuteBefore" [hidden]="!juteForm.get('hasJuteBefore').value">
      {{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.PATH_LABELS.JUTE_AFTER_SAME_AS_BEFORE' | bmsTranslate }}
    </mat-checkbox>

    <div *ngIf="!juteForm.get('juteAfter').get('sameAsJuteBefore').value" fxLayout="column">
      <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="left center">
        <mat-form-field fxFlex="30">
          <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
          <input matInput appL10nDecimal formControlName="commercialHeightInMM" type="number" min="0" />
          <span matSuffix>{{ 'GENERAL.UNIT.MILLIMETER' | bmsTranslate }}</span>
          <mat-error *ngIf="canShowErrorForFormControl('required', 'juteAfter.commercialHeightInMM')">
            {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
          </mat-error>
          <mat-error *ngIf="canShowErrorForFormControl('min', 'juteAfter.commercialHeightInMM')">
            {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: 1} }}
          </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="31">
          <mat-label>{{ 'GENERAL.DIMENSIONS.HEIGHT' | bmsTranslate }}</mat-label>
          <input matInput appL10nDecimal formControlName="technicalHeightInPicks" type="number" min="0" />
          <span matSuffix>{{ 'GENERAL.UNIT.PICKS' | bmsTranslate }}</span>
          <mat-error *ngIf="canShowErrorForFormControl('required', 'juteAfter.technicalHeightInPicks')">
            {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
          </mat-error>
          <mat-error *ngIf="canShowMultipleError('juteAfter.technicalHeightInPicks')">
            {{ 'GENERAL.ERRORS.MULTIPLE_VALUE' | bmsTranslate: {value: getMultipleValue()} }}
          </mat-error>
          <mat-error *ngIf="canShowErrorForFormControl('min', 'juteAfter.technicalHeightInPicks')">
            {{ 'GENERAL.ERRORS.MIN_VALUE' | bmsTranslate: {min: machineQuality.weaveStructure.picksPerColorLine} }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="jute-after-position" fxLayout="row" fxLayoutGap="16px" formGroupName="position" fxLayoutAlign="left center" *ngIf="canShowAddJuteBeforeOrAfterPathLabels()">
        <p class="b1 font-weight-semibold">{{ 'GENERAL.ACTIONS.ADD_OBJECT' | bmsTranslate: {object: 'PRODUCTION_ORDER.WEAVE_PLAN.JUTE.JUTE' | bmsTranslate} }}</p>

        <mat-checkbox formControlName="beforePathLabel">
          {{ 'PRODUCTION_ORDER.WEAVE_PLAN.JUTE.BEFORE_PATH_LABEL' | bmsTranslate }}
        </mat-checkbox>
        <mat-checkbox formControlName="afterPathLabel">
          {{ 'PRODUCTION_ORDER.WEAVE_PLAN.JUTE.AFTER_PATH_LABEL' | bmsTranslate }}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="jute-pattern-container" fxLayout.gt-sm="row" fxLayout="column" fxLayoutGap="16px" fxLayoutAlign="start" fxLayoutAlign.gt-sm="start end" *ngIf="canShowJutePattern()">
    <mat-form-field class="full-width">
      <mat-label>{{ 'PRODUCTION_ORDER.WEAVE_PLAN.PATTERN_OR_DRAWING' | bmsTranslate }}</mat-label>
      <vdw-object-selection
        formControlName="pattern"
        [objectName]="'PRODUCTION_ORDER.WEAVE_PLAN.PATTERN_OR_DRAWING' | bmsTranslate | lowercase"
        [conditionalChipValueKey]="JUTE_PATTERN_CONDITIONAL_CHIP_VALUE_KEY"
        (selectClicked)="selectPatternForJute()"
      ></vdw-object-selection>
      <mat-error *vdwCanShowErrorForFormControl="'pattern'; error: 'required'">
        {{ 'GENERAL.ERRORS.REQUIRED' | bmsTranslate }}
      </mat-error>
    </mat-form-field>
    <app-pattern-example
      *ngIf="hasChosenJutePattern()"
      [weaveQualityType]="weaveQualityType"
      [canShowColor]="true"
      [pattern]="juteForm.get('pattern').value"
      [observePatternBeforeVisible]="true"
      [weaveStructureId]="machineQuality.weaveStructure.id"
      (patternReceived)="juteZoneLoaded.emit()"
    ></app-pattern-example>
  </div>
</form>
